import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "./Util/Card.js";
import CardBody from "./Util/CardBody.js";
import CardHeader from "./Util/CardHeader.js";
import CardFooter from "./Util/CardFooter.js";
import CustomInput from "./Util/CustomInput.js";
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
import Icon from "@material-ui/core/Icon";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import * as styles from "../newStyles.styles";
import { calendyFormStyle } from "./Util/cardStyle";
import { slackMessage } from "apis";

const useStyles = makeStyles(calendyFormStyle);
function CalendyForm(props) {
  const { text } = props;
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);

  const [contact, setContact] = useState({
    name: "",
    email: "",
    phone: "",
    desc: "",
  });
  const [error, setError] = useState("");
  const classes = useStyles();

  const update = (e, field) => {
    setContact({ ...contact, [field]: e.target.value });
  };
  const redirectToCalendy = (e) => {
    let phoneString =
      contact.phone.length === 10 ? "1" + contact.phone : contact.phone;
    slackMessage(
      contact.name,
      contact.email,
      phoneString,
      "Scheduled a call via Calendy."
    );
    e.preventDefault();

    var url =
      "https://calendly.com/mobile360/intro-to-mobile360-demo?name=" +
      contact.name +
      "&email=" +
      contact.email +
      "&a1=" +
      phoneString;
    window.open(url, "_blank");
  };

  return (
    <Card className={classes[cardAnimaton]}>
      <form className={classes.form} onSubmit={redirectToCalendy}>
        <CardHeader color="primary" className={classes.cardHeader}>
          <h3>Ready to Streamline your Business?</h3>
        </CardHeader>
        <p className={classes.divider} style={{ padding: "20px" }}>
          {text} Let's set up a quick call to see what we can do for{" "}
          <span className={styles.styledUnderline}>you!</span>
        </p>
        <CardBody>
          <CustomInput
            labelText="Full Name..."
            id="first"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "text",
              endAdornment: (
                <InputAdornment position="end">
                  <People className={classes.inputIconsColor} />
                </InputAdornment>
              ),
              value: contact.name,
              required: true,
              onChange: (e) => {
                update(e, "name");
              },
            }}
          />
          <CustomInput
            labelText="Email..."
            id="email"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "email",
              endAdornment: (
                <InputAdornment position="end">
                  <Email className={classes.inputIconsColor} />
                </InputAdornment>
              ),
              value: contact.email,
              required: true,
              onChange: (e) => {
                update(e, "email");
              },
            }}
          />
          <CustomInput
            labelText="Phone"
            id="phone"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "tel",
              pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
              endAdornment: (
                <InputAdornment position="end">
                  <Icon className={classes.inputIconsColor}>phone</Icon>
                </InputAdornment>
              ),
              autoComplete: "off",
              value: contact.phone,
              required: true,
              onChange: (e) => {
                update(e, "phone");
              },
            }}
          />
        </CardBody>
        <CardFooter className={classes.cardFooter}>
          {error}
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            size="lg"
            style={{
              textTransform: "none",
              width: "auto",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            Schedule
          </Button>
        </CardFooter>
      </form>
    </Card>
  );
}

export default CalendyForm;
